import "intersection-observer";

import { GatsbyImage, getImage } from "gatsby-plugin-image";
import React from "react";
import styled from "styled-components";
import ReactPlayer from "react-player/vimeo";
import { useInView } from "react-intersection-observer";

const StyledWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  pointer-events: none;
`;

const StyledVideoWrapper = styled.div`
  position: relative;
  padding-top: ${(props) => props.dimensions};
  width: 100%;
`;

const StyledReactPlayer = styled(ReactPlayer)`
  position: absolute;
  top: 0;
  left: 0;
`;

const StyledPlaceholder = styled.div`
  position: absolute !important;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
`;

const KCReactPlayer = React.forwardRef(
  (
    {
      url,
      img,
      dimensions = "56.25%",
      handleProgress,
      isForceStart = false,
      ...props
    },
    videoRef
  ) => {
    const [ref, inView] = useInView({
      threshold: 0,
      initialInView: isForceStart,
    });

    return (
      <StyledWrapper>
        {img && (
          <StyledPlaceholder>
            <GatsbyImage
              image={getImage(img)}
              alt="video"
              style={{ width: "100%", height: "100%" }}
              imgStyle={{
                objectFit: "cover",
                objectPosition: "top",
              }}
            />
          </StyledPlaceholder>
        )}
        <StyledVideoWrapper ref={ref} dimensions={dimensions}>
          <StyledReactPlayer
            ref={videoRef}
            width="100%"
            height="100%"
            light={false}
            controls={false}
            playing={inView}
            playsinline={true}
            muted={true}
            volume={0}
            loop={true}
            onProgress={handleProgress}
            url={url}
          />
        </StyledVideoWrapper>
      </StyledWrapper>
    );
  }
);

export default KCReactPlayer;
